import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Header from './Header';
import Table from './Table';
import Pagination from './Pagination';

export default inject('root')(
  observer(({ root }) => {
    const { terminals, loadTerminals, loading, pagination } = root.terminals;

    useEffect(() => {
      loadTerminals();
    }, []);

    return (
      <>
        <Header />
        <Table
          loading={loading}
          terminals={terminals}
        />
        <Pagination pagination={pagination} />
      </>
    );
  })
)
